import {
    Alert,
    Box,
    Button,
    Container,
    FormControl,
    InputAdornment,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select,
    Skeleton,
    Snackbar,
    Stack,
    TextField,
    Typography
} from '@mui/material';

import React, { useEffect, useRef, useState } from 'react';

import { styled } from '@mui/material/styles';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { useSelector } from 'react-redux';

import SearchIcon from '@mui/icons-material/Search';

import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';

import Apercu from './Apercu';

import { useDispatch } from 'react-redux';

import {
    ajoutsuccess,
    showapercu
} from "./AchatsSlice";


// IMPORTANT :
// Les composants styled sont définis EN DEHORS de NouvelAchat.
// Ils ne seront donc plus recréés à chaque render.

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },

    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));


const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },

    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


export default function NouvelAchat() {

    const userData = useSelector(state => state.userData);

    const id = userData.id;
    const apitoken = userData.apitoken;

    const apiUrl = process.env.REACT_APP_API_URL;


    const achatsData = useSelector(state => state.achatsData);

    const ListFournisseur = achatsData.listFournisseurs;


    const dispatch = useDispatch();

    const navigate = useNavigate();


    const [Progession, setProgession] = useState(false);

    const [valFournisseur, setvalFournisseur] = useState('');

    const [etatFacture, setEtatFacture] = useState('Réglée');

    const [Chargement, setChargement] = useState(false);

    const [rechercheInput, setRchercheInput] = useState('');

    const [valMarque, setMarque] = useState('Tout');

    const [valCategorie, setCategorie] = useState('Tout');

    const [listMarque, setListMarque] = useState([]);

    const [listCat, setListCat] = useState([]);

    const [listProduits, setListProduits] = useState([]);

    const [montant, setMontant] = useState(0);


    const today = new Date();

    const year = today.getFullYear();

    const month = String(
        today.getMonth() + 1
    ).padStart(2, '0');

    const day = String(
        today.getDate()
    ).padStart(2, '0');

    const todayDate =
        `${year}-${month}-${day}`;


    const [selectedDate, setSelectedDate] =
        useState(todayDate);

    const [selectedDate2, setSelectedDate2] =
        useState(todayDate);


    /*
     * Refs
     */

    const fournisseurField = useRef('');

    const factureField = useRef('');

    const montantField = useRef('');

    const etatField = useRef('');

    const dateArrivageField = useRef('');

    const dateReglementField = useRef('');

    const rechercheField = useRef('');


    /*
     * Liste des produits de l'achat.
     *
     * useRef est volontaire ici afin de ne pas provoquer
     * de render à chaque modification.
     */

    const listAchats = useRef([]);


    /*
     * Handlers
     */

    const handleFournisseurChange = (event) => {

        setvalFournisseur(
            event.target.value
        );

    };


    const handleDateChange = (event) => {

        setSelectedDate(
            event.target.value
        );

    };


    const handleDateChange2 = (event) => {

        setSelectedDate2(
            event.target.value
        );

    };


    const handleEtatChange = (event) => {

        setEtatFacture(
            event.target.value
        );

    };


    const handleMarqueChange = (event) => {

        setMarque(
            event.target.value
        );

    };


    const handleCategorieChange = (event) => {

        setCategorie(
            event.target.value
        );

    };


    /*
     * Date
     */

    const formatDateToIso = (dateString) => {

        const formattedDate =
            new Date(`${dateString}T00:00:00Z`);

        formattedDate.setHours(
            23,
            59,
            59,
            999
        );

        return formattedDate.toISOString();

    };


    /*
     * Supprime les produits dont quantité = 0
     */

    const removeZeroStock = (list) => {

        return list.current.filter(
            item => Number(item.stock) > 0
        );

    };


    /*
     * Aperçu
     */

    const ShowApercu = () => {

        dispatch(
            showapercu(true)
        );

    };


    /*
     * Recherche
     */

    const Recherche = () => {

        const recherche =
            rechercheField.current.value;

        if (
            recherche !== rechercheInput
        ) {

            setRchercheInput(
                recherche
            );

        }

    };


    /*
     * Récupération marques
     */

    const getMarque = async () => {

        try {

            const response =
                await axios.post(
                    `${apiUrl}marques/${id}/${apitoken}`,
                    {
                        timeout: 20000,
                    }
                );

            setListMarque(
                response.data
            );

        }
        catch (error) {

            navigate('/');

        }

    };


    /*
     * Récupération catégories
     */

    const getCategorie = async () => {

        try {

            const response =
                await axios.post(
                    `${apiUrl}categories/${id}/${apitoken}`,
                    {
                        timeout: 20000,
                    }
                );

            setListCat(
                response.data
            );

        }
        catch (error) {

            navigate('/');

        }

    };


    /*
     * Récupération produits
     */

    const getProduits = async () => {

        setChargement(true);

        try {

            const response =
                await axios.post(
                    `${apiUrl}produits/${id}/${apitoken}`,
                    {
                        timeout: 20000,
                    }
                );

            setListProduits(
                response.data
            );

        }
        catch (error) {

            navigate('/');

        }

        setChargement(false);

    };


    /*
     * Mise à jour quantité + calcul automatique montant TTC
     */

    const StockUpdate = (event) => {

        const qte =
            Number(event.target.value) || 0;

        const idProduit =
            event.target.id;


        /*
         * On retrouve directement le produit concerné.
         *
         * Pas besoin ici de refaire un map complet de listProduits,
         * puisque nous ne modifions pas listProduits.
         */

        const product =
            listProduits.find(
                item => item._id === idProduit
            );


        if (!product) {
            return;
        }


        const stock = qte;

        const unite =
            stock * product.qte_pack;


        const valeurs = {

            _id: product._id,

            designation:
                product.designation,

            stock,

            unite,

            prix_achat:
                product.prix_achat,

            qte_pack:
                product.qte_pack

        };


        /*
         * Vérifie si le produit est déjà présent
         */

        const existingProductIndex =
            listAchats.current.findIndex(
                item =>
                    item._id === product._id
            );


        if (
            existingProductIndex !== -1
        ) {

            listAchats.current[
                existingProductIndex
            ] = valeurs;

        }
        else {

            listAchats.current.push(
                valeurs
            );

        }


        /*
         * Calcul total HT
         */

        const totalHT =
            listAchats.current.reduce(
                (sum, item) => {

                    return sum + (
                        item.stock *
                        item.qte_pack *
                        item.prix_achat
                    );

                },
                0
            );


        /*
         * TVA 20 %
         */

        const totalTTC =
            totalHT * 1.20;


        /*
         * Le setMontant provoque un render.
         *
         * Ce n'est maintenant plus un problème car
         * ShowList n'est plus utilisé comme <ShowList />
         * et les styled components sont définis hors
         * du composant.
         */

        setMontant(
            Number(
                totalTTC.toFixed(2)
            )
        );

    };


    /*
     * Affichage produits
     */

    function ShowList() {

        if (
            listProduits.length > 0
        ) {

            let listFiltre =
                listProduits;


            /*
             * Recherche
             */

            if (
                rechercheInput.length > 2
            ) {

                listFiltre =
                    listFiltre.filter(
                        produit =>
                            produit.designation
                                .toLowerCase()
                                .includes(
                                    rechercheInput.toLowerCase()
                                )
                    );

            }


            /*
             * Marque
             */

            if (
                valMarque !== "Tout"
            ) {

                listFiltre =
                    listFiltre.filter(
                        produit =>
                            produit.marque["id"] ===
                            valMarque
                    );

            }


            /*
             * Catégorie
             */

            if (
                valCategorie !== "Tout"
            ) {

                listFiltre =
                    listFiltre.filter(
                        produit =>
                            produit.categorie["id"] ===
                            valCategorie
                    );

            }


            return listFiltre.map(
                Produit => {

                    /*
                     * Récupère la quantité déjà saisie
                     */

                    const currentQte =
                        listAchats.current.find(
                            item =>
                                item._id ===
                                Produit._id
                        );


                    let stock = "0";


                    if (currentQte) {

                        stock =
                            currentQte.stock;

                    }


                    return (

                        <StyledTableRow
                            key={Produit._id}
                        >

                            <StyledTableCell
                                component="th"
                                scope="row"
                            >

                                {
                                    Produit.designation
                                }

                            </StyledTableCell>


                            <StyledTableCell
                                component="th"
                                scope="row"
                            >

                                <TextField

                                    onChange={
                                        StockUpdate
                                    }

                                    defaultValue={
                                        stock
                                    }

                                    id={
                                        Produit._id
                                    }

                                    label="Packs"

                                    size="normal"

                                    type="number"

                                    variant="outlined"

                                />

                            </StyledTableCell>

                        </StyledTableRow>

                    );

                }
            );

        }


        return (

            <TableRow>

                <TableCell
                    colSpan={6}
                    align="center"
                >

                    Pas de données

                </TableCell>

            </TableRow>

        );

    }


    /*
     * Enregistrer achat
     */

    const Ajouter = async () => {

        const idfournisseur =
            fournisseurField.current.value;


        if (
            idfournisseur === ""
        ) {

            alert(
                "veillez sélectionner un fournisseur"
            );

            return;

        }


        let fournisseur =
            ListFournisseur.find(
                item =>
                    item._id ===
                    idfournisseur
            );


        fournisseur =
            fournisseur.designation;


        fournisseur = {

            id:
                idfournisseur,

            designation:
                fournisseur,

        };


        let facture =
            factureField.current.value;


        if (
            facture === ""
        ) {

            facture = 0;

        }


        const etat =
            etatField.current.value;


        const dateArrivage =
            formatDateToIso(
                dateArrivageField.current.value
            );


        const dateReglement =
            formatDateToIso(
                dateReglementField.current.value
            );


        const produits =
            removeZeroStock(
                listAchats
            );


        setProgession(true);


        try {

            const response =
                await axios.post(

                    `${apiUrl}new/achat/${id}/${apitoken}`,

                    {

                        fournisseur,

                        facture,

                        montant,

                        etat,

                        dateArrivage,

                        dateReglement,

                        produits,

                    },

                    {

                        timeout: 20000,

                    }

                );


            dispatch(
                ajoutsuccess(true)
            );


            navigate(
                '/home/achats',
                {
                    replace: true
                }
            );

        }
        catch (error) {

            navigate('/');

        }


        setProgession(false);

    };


    /*
     * Initialisation
     */

    useEffect(() => {

        getProduits();

        getMarque();

        getCategorie();

    }, []);


    return (

        <Container
            maxWidth="lg"
            sx={{
                marginTop: '40px'
            }}
        >

            <Typography
                variant="h4"
                align="center"
                color="primary"
            >

                Nouvel Achat

            </Typography>


            {
                Chargement
                    ?

                    <Skeleton
                        sx={{
                            marginTop: '20px'
                        }}
                        variant="rounded"
                        height={56}
                    />

                    :

                    <Box
                        display="flex"
                        width="100%"
                        mt={5}
                    >

                        <FormControl
                            sx={{
                                minWidth: 150
                            }}
                        >

                            <InputLabel>
                                Fournisseur
                            </InputLabel>


                            <Select

                                id={valFournisseur}

                                inputRef={
                                    fournisseurField
                                }

                                value={
                                    valFournisseur
                                }

                                label="Fournisseur"

                                onChange={
                                    handleFournisseurChange
                                }

                            >

                                {
                                    ListFournisseur.map(
                                        item => (

                                            <MenuItem
                                                key={
                                                    item._id
                                                }
                                                value={
                                                    item._id
                                                }
                                            >

                                                {
                                                    item.designation
                                                }

                                            </MenuItem>

                                        )
                                    )
                                }

                            </Select>

                        </FormControl>


                        <TextField

                            sx={{
                                marginLeft: 2
                            }}

                            inputRef={
                                factureField
                            }

                            label="N° Facture"

                            size="normal"

                            variant="outlined"

                        />


                        <TextField

                            sx={{
                                marginLeft: 2
                            }}

                            value={
                                montant
                            }

                            onChange={
                                e =>
                                    setMontant(
                                        e.target.value
                                    )
                            }

                            label="Montant"

                            size="normal"

                            type="number"

                            variant="outlined"

                        />


                        <FormControl
                            sx={{
                                minWidth: 150,
                                marginLeft: 2
                            }}
                        >

                            <InputLabel>
                                Etat
                            </InputLabel>


                            <Select

                                label="Etat"

                                inputRef={
                                    etatField
                                }

                                onChange={
                                    handleEtatChange
                                }

                                value={
                                    etatFacture
                                }

                            >

                                <MenuItem
                                    value="Réglée"
                                >

                                    Réglée

                                </MenuItem>


                                <MenuItem
                                    value="Non Réglée"
                                >

                                    Non Réglée

                                </MenuItem>

                            </Select>

                        </FormControl>


                        <TextField

                            sx={{
                                marginLeft: 2
                            }}

                            inputRef={
                                dateArrivageField
                            }

                            value={
                                selectedDate
                            }

                            onChange={
                                handleDateChange
                            }

                            label="Date d'arrivage"

                            size="normal"

                            type="date"

                            variant="outlined"

                        />


                        <TextField

                            sx={{
                                marginLeft: 2
                            }}

                            inputRef={
                                dateReglementField
                            }

                            value={
                                selectedDate2
                            }

                            onChange={
                                handleDateChange2
                            }

                            label="Date réglement"

                            size="normal"

                            type="date"

                            variant="outlined"

                        />

                    </Box>
            }


            <Typography
                variant="h4"
                align="center"
                color="primary"
                sx={{
                    marginTop: '40px'
                }}
            >

                Produits

            </Typography>


            <Box
                display="flex"
                width="100%"
                mt={5}
            >

                {
                    Chargement
                        ?

                        <Skeleton
                            sx={{
                                marginTop: '20px'
                            }}
                            variant="rounded"
                            height={56}
                            width={241}
                        />

                        :

                        <TextField

                            onKeyUp={
                                Recherche
                            }

                            inputRef={
                                rechercheField
                            }

                            label="Recherche"

                            size="normal"

                            InputProps={{

                                startAdornment: (

                                    <InputAdornment
                                        position="start"
                                    >

                                        <SearchIcon />

                                    </InputAdornment>

                                ),

                            }}

                            variant="outlined"

                        />
                }


                <Box
                    sx={{
                        marginLeft: 2
                    }}
                >

                    {
                        Chargement
                            ?

                            <Skeleton
                                sx={{
                                    marginTop: '20px'
                                }}
                                variant="rounded"
                                height={56}
                                width={150}
                            />

                            :

                            <FormControl
                                sx={{
                                    minWidth: 150
                                }}
                            >

                                <InputLabel>
                                    Marque
                                </InputLabel>


                                <Select

                                    value={
                                        valMarque
                                    }

                                    label="Marque"

                                    onChange={
                                        handleMarqueChange
                                    }

                                >

                                    <MenuItem
                                        value="Tout"
                                    >

                                        Tout

                                    </MenuItem>


                                    {
                                        listMarque.map(
                                            item => (

                                                <MenuItem
                                                    key={
                                                        item._id
                                                    }
                                                    value={
                                                        item._id
                                                    }
                                                >

                                                    {
                                                        item.designation
                                                    }

                                                </MenuItem>

                                            )
                                        )
                                    }

                                </Select>

                            </FormControl>
                    }

                </Box>


                <Box
                    sx={{
                        marginLeft: 2
                    }}
                >

                    {
                        Chargement
                            ?

                            <Skeleton
                                sx={{
                                    marginTop: '20px'
                                }}
                                variant="rounded"
                                height={56}
                                width={150}
                            />

                            :

                            <FormControl
                                sx={{
                                    minWidth: 150
                                }}
                            >

                                <InputLabel>
                                    Catégorie
                                </InputLabel>


                                <Select

                                    value={
                                        valCategorie
                                    }

                                    label="Catégorie"

                                    onChange={
                                        handleCategorieChange
                                    }

                                >

                                    <MenuItem
                                        value="Tout"
                                    >

                                        Tout

                                    </MenuItem>


                                    {
                                        listCat.map(
                                            item => (

                                                <MenuItem
                                                    key={
                                                        item._id
                                                    }
                                                    value={
                                                        item._id
                                                    }
                                                >

                                                    {
                                                        item.designation
                                                    }

                                                </MenuItem>

                                            )
                                        )
                                    }

                                </Select>

                            </FormControl>
                    }

                </Box>

            </Box>


            {
                Chargement
                    ?

                    <Skeleton
                        sx={{
                            marginTop: '20px'
                        }}
                        variant="rounded"
                        height={200}
                    />

                    :

                    <TableContainer
                        sx={{
                            marginTop: '20px'
                        }}
                        component={Paper}
                    >

                        {
                            Progession
                                ?

                                <Box>

                                    <Stack
                                        sx={{
                                            width: '100%',
                                            color: 'grey.500'
                                        }}
                                        spacing={2}
                                    >

                                        <LinearProgress
                                            color="success"
                                        />

                                    </Stack>

                                </Box>

                                :

                                null
                        }


                        <Table
                            sx={{
                                minWidth: 700
                            }}
                            aria-label="customized table"
                        >

                            <TableHead>

                                <TableRow>

                                    <StyledTableCell>
                                        Désignation
                                    </StyledTableCell>

                                    <StyledTableCell>
                                        Quantité
                                    </StyledTableCell>

                                </TableRow>

                            </TableHead>


                            <TableBody>

                                {ShowList()}

                            </TableBody>

                        </Table>

                    </TableContainer>
            }


            <Box
                display="flex"
                width="100%"
                mt={2}
            >

                <Box
                    style={{
                        marginLeft: 'auto'
                    }}
                >

                    {
                        Chargement
                            ?

                            <Skeleton
                                sx={{
                                    marginTop: '20px'
                                }}
                                variant="rounded"
                                height={56}
                                width={241}
                            />

                            :

                            <Button

                                sx={{
                                    marginRight: '20px'
                                }}

                                variant="contained"

                                size="large"

                                color="primary"

                                startIcon={
                                    <RemoveRedEyeOutlinedIcon />
                                }

                                onClick={
                                    ShowApercu
                                }

                            >

                                Aperçu

                            </Button>
                    }


                    {
                        Chargement
                            ?

                            <Skeleton
                                sx={{
                                    marginTop: '20px'
                                }}
                                variant="rounded"
                                height={56}
                                width={241}
                            />

                            :

                            <Button

                                variant="contained"

                                disabled={
                                    Progession
                                }

                                size="large"

                                color="success"

                                startIcon={
                                    <CloudDoneOutlinedIcon />
                                }

                                onClick={
                                    Ajouter
                                }

                            >

                                Enregistrer

                            </Button>
                    }

                </Box>

            </Box>


            <Apercu
                Achats={
                    listAchats
                }
            />

        </Container>

    );
}